/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

interface ProductImgItemProps {
  idx: number;
  selectImg: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  active: boolean;
  imgSrc: string;
}

function ProductImgItem({
  idx,
  selectImg,
  active,
  imgSrc,
}: ProductImgItemProps) {
  return (
    <div
      className="relative z-10 w-[4rem] md:w-[8rem] h-[4rem]  md:h-[8rem] p-1 cursor-pointer"
      data-idx={idx}
      onClick={selectImg}
    >
      <img
        className={`w-full h-full rounded-lg md:rounded-2xl transition relative object-cover ${
          active ? 'opacity-100' : 'opacity-60'
        }`}
        src={imgSrc}
        alt="productImg"
      />
    </div>
  );
}

export default ProductImgItem;
